import { render, staticRenderFns } from "./PaymentRecord.vue?vue&type=template&id=769d230a&scoped=true&"
import script from "./PaymentRecord.vue?vue&type=script&lang=js&"
export * from "./PaymentRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769d230a",
  null
  
)

export default component.exports